(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-path-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-path-js'.");
    }
    root['d2v-path-js'] = factory(typeof this['d2v-path-js'] === 'undefined' ? {} : this['d2v-path-js'], kotlin);
  }
}(this, function (_, Kotlin) {
  'use strict';
  var math = Kotlin.kotlin.math;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var StringBuilder = Kotlin.kotlin.text.StringBuilder;
  var toString = Kotlin.toString;
  var IllegalArgumentException_init = Kotlin.kotlin.IllegalArgumentException_init_pdl1vj$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var pi;
  var tau;
  var epsilon;
  var tauEpsilon;
  function PathAdapter() {
  }
  PathAdapter.prototype.arc_6p3vsx$ = function (centerX, centerY, radius, startAngle, endAngle, counterClockWise, callback$default) {
    if (counterClockWise === void 0)
      counterClockWise = false;
    callback$default ? callback$default(centerX, centerY, radius, startAngle, endAngle, counterClockWise) : this.arc_6p3vsx$$default(centerX, centerY, radius, startAngle, endAngle, counterClockWise);
  };
  PathAdapter.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'PathAdapter', interfaces: []};
  function SvgPath() {
    this.x0_0 = 0.0;
    this.y0_0 = 0.0;
    this.x1_0 = null;
    this.y1_0 = null;
    this._path = new StringBuilder();
  }
  Object.defineProperty(SvgPath.prototype, 'path', {get: function () {
    return this._path.toString();
  }});
  SvgPath.prototype.clearPath = function () {
    this._path = new StringBuilder();
  };
  SvgPath.prototype.moveTo_lu1900$ = function (x, y) {
    this.x0_0 = x;
    this.y0_0 = y;
    this.x1_0 = x;
    this.y1_0 = y;
    this._path.append_gw00v9$('M' + x + ',' + y);
  };
  SvgPath.prototype.lineTo_lu1900$ = function (x, y) {
    this.x1_0 = x;
    this.y1_0 = y;
    this._path.append_gw00v9$('L' + x + ',' + y);
  };
  SvgPath.prototype.closePath = function () {
    if (this.x1_0 != null) {
      this.x1_0 = this.x0_0;
      this.y1_0 = this.y0_0;
      this._path.append_gw00v9$('Z');
    }
  };
  SvgPath.prototype.quadraticCurveTo_6y0v78$ = function (x1, y1, x, y) {
    this.x1_0 = x;
    this.y1_0 = y;
    this._path.append_gw00v9$('Q' + x1 + ',' + y1 + ',' + x + ',' + y);
  };
  SvgPath.prototype.bezierCurveTo_15yvbs$ = function (x1, y1, x2, y2, x, y) {
    this.x1_0 = x;
    this.y1_0 = y;
    this._path.append_gw00v9$('C' + x1 + ',' + y1 + ',' + x2 + ',' + y2 + ',' + x + ',' + y);
  };
  var Math_0 = Math;
  SvgPath.prototype.arcTo_1lq62i$ = function (fromX, fromY, toX, toY, radius) {
    var tmp$, tmp$_0;
    var r = radius;
    if (r < 0.0)
      throw IllegalArgumentException_init('Negative radius:' + toString(radius));
    var x1 = fromX;
    var y1 = fromY;
    var x2 = toX;
    var y2 = toY;
    var x0 = (tmp$ = this.x1_0) != null ? tmp$ : 0.0;
    var y0 = (tmp$_0 = this.y1_0) != null ? tmp$_0 : 0.0;
    var x21 = x2 - x1;
    var y21 = y2 - y1;
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var l01_2 = x01 * x01 + y01 * y01;
    if (this.x1_0 == null) {
      this.x1_0 = x1;
      this.y1_0 = y1;
      this._path.append_gw00v9$('M' + x1 + ',' + y1);
    }
     else if (l01_2 > epsilon) {
      var x = y01 * x21 - y21 * x01;
      if (Math_0.abs(x) <= epsilon || r === 0.0) {
        this.x1_0 = x1;
        this.y1_0 = y1;
        this._path.append_gw00v9$('L' + x1 + ',' + y1);
      }
       else {
        var x20 = x2 - x0;
        var y20 = y2 - y0;
        var l21_2 = x21 * x21 + y21 * y21;
        var l20_2 = x20 * x20 + y20 * y20;
        var l21 = Math_0.sqrt(l21_2);
        var l01 = Math_0.sqrt(l01_2);
        var tmp$_1 = pi;
        var x_0 = (l21_2 + l01_2 - l20_2) / (2 * l21 * l01);
        var x_1 = (tmp$_1 - Math_0.acos(x_0)) / 2;
        var l = r * Math_0.tan(x_1);
        var t01 = l / l01;
        var t21 = l / l21;
        var x_2 = t01 - 1;
        if (Math_0.abs(x_2) > epsilon) {
          this._path.append_gw00v9$('L' + (x1 + t01 * x01) + ',' + (y1 + t01 * y01));
        }
        this.x1_0 = x1 + t21 * x21;
        this.y1_0 = y1 + t21 * y21;
        var yes = y01 * x20 > x01 * y20 ? 1 : 0;
        this._path.append_gw00v9$('A' + r + ',' + r + ',0,0,' + yes + ',' + toString(this.x1_0) + ',' + toString(this.y1_0));
      }
    }
  };
  SvgPath.prototype.arc_6p3vsx$$default = function (centerX, centerY, radius, startAngle, endAngle, counterClockWise) {
    var r = radius;
    if (r < 0.0)
      throw IllegalArgumentException_init('Negative radius:' + toString(radius));
    var a0 = startAngle;
    var a1 = endAngle;
    var x = centerX;
    var y = centerY;
    var dx = r * Math_0.cos(a0);
    var dy = r * Math_0.sin(a0);
    var x0 = x + dx;
    var y0 = y + dy;
    var cw = counterClockWise ? 0 : 1;
    var da = counterClockWise ? a0 - a1 : a1 - a0;
    var $receiver = this.x1_0;
    if ($receiver == null) {
      this._path.append_gw00v9$('M' + x0 + ',' + y0);
    }
     else {
      var x_0 = $receiver - x0;
      var tmp$ = Math_0.abs(x_0) > epsilon;
      if (!tmp$) {
        var x_1 = ensureNotNull(this.y1_0) - y0;
        tmp$ = Math_0.abs(x_1) > epsilon;
      }
      if (tmp$) {
        this._path.append_gw00v9$('L' + x0 + ',' + y0);
      }
    }
    if (r < epsilon)
      return;
    if (da < 0)
      da = da % tau + tau;
    if (da > tauEpsilon) {
      this.x1_0 = x0;
      this.y1_0 = y0;
      this._path.append_gw00v9$('A' + r + ',' + r + ',0,1,' + cw + ',' + (x - dx) + ',' + (y - dy) + 'A' + r + ',' + r + ',0,1,' + cw + ',' + x0 + ',' + y0);
    }
     else if (da > epsilon) {
      this.x1_0 = x + r * Math_0.cos(a1);
      this.y1_0 = y + r * Math_0.sin(a1);
      this._path.append_gw00v9$('A' + r + ',' + r + ',0,' + (da >= pi ? 1 : 0) + ',' + cw + ',' + toString(this.x1_0) + ',' + toString(this.y1_0));
    }
  };
  SvgPath.prototype.rect_6y0v78$ = function (x, y, w, h) {
    this.x0_0 = x;
    this.x1_0 = x;
    this.y0_0 = y;
    this.y1_0 = y;
    this._path.append_gw00v9$('M' + x + ',' + y + 'h' + w + 'v' + h + 'h' + -w + 'Z');
  };
  SvgPath.$metadata$ = {kind: Kind_CLASS, simpleName: 'SvgPath', interfaces: [PathAdapter]};
  function CanvasDrawContext(canvas) {
    this.canvas = canvas;
  }
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$path = package$data2viz.path || (package$data2viz.path = {});
  package$path.PathAdapter = PathAdapter;
  package$path.SvgPath = SvgPath;
  package$path.CanvasDrawContext = CanvasDrawContext;
  SvgPath.prototype.arc_6p3vsx$ = PathAdapter.prototype.arc_6p3vsx$;
  CanvasDrawContext.prototype.arc_6p3vsx$ = PathAdapter.prototype.arc_6p3vsx$;
  pi = math.PI;
  tau = 2 * pi;
  epsilon = 1.0E-6;
  tauEpsilon = tau - epsilon;
  return _;
}));

//# sourceMappingURL=d2v-path-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-path-js.js
// module id = 10
// module chunks = 0